import type { LeadReadiness, ReadinessValue } from '@aikoa/common'
import { useTranslations, type TFunction } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { Heading3 } from '~/components/typography/Titles'
import { Text } from '~/components/ui/text'
import { cn, formatTimeAgo } from '~/lib/utils'
import Icon from '../Icon'

function getReadinessLabel(value: ReadinessValue, t: TFunction<'leads'>): string {
  switch (value) {
    case 1:
      return t(($) => $.detail.readiness.readyToMove)
    case 0.8:
      return t(($) => $.detail.readiness.activelySearching)
    case 0.6:
      return t(($) => $.detail.readiness.sellingFirst)
    case 0.3:
      return t(($) => $.detail.readiness.earlyStage)
    case 0:
      return t(($) => $.detail.readiness.notTimely)
  }
}

export function LeadReadinessIntelligence({
  readiness,
  className,
}: {
  readiness: LeadReadiness | null
  className?: string
}) {
  const { t } = useTranslations('leads')

  if (!readiness) {
    return (
      <View className={cn('rounded-xl border border-border bg-background px-4 py-3', className)}>
        <View className="flex-row items-center gap-2">
          <Icon name="time-outline" size={18} color="#9ca3af" />
          <Text className="text-sm text-secondary">
            {t(($) => $.detail.matchingAssets.noReadinessData)}
          </Text>
        </View>
      </View>
    )
  }

  return (
    <View className={cn('gap-3', className)}>
      <Heading3 className="text-left font-normal text-base">
        {t(($) => $.detail.readiness.title)}
      </Heading3>

      <View className="rounded-xl bg-muted px-4 py-3">
        <Text className="flex w-full flex-row items-baseline gap-2 text-primary">
          <Text className="font-semibold text-base">{getReadinessLabel(readiness.value, t)}</Text>
          <Text className="ml-auto font-light text-sm">
            ({formatTimeAgo(readiness.mostRecentDate)})
          </Text>
        </Text>
      </View>
    </View>
  )
}
